// components/Admin/EmoticonManager/EmoticonStatsChart.jsx

import React, { useEffect, useState } from 'react';
import {
    BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, LabelList
} from 'recharts';
import {
    Box, Typography, CircularProgress, useTheme, useMediaQuery
} from '@mui/material';
import api from '../../../api/axios';

const EmoticonStatsChart = () => {
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        api.get('/api/management/emoticon-stats/')
            .then(res => setStats(res.data))
            .catch(err => console.error('통계 불러오기 실패', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <CircularProgress sx={{ display: 'block', mx: 'auto', my: 3 }} />;

    return (
        <Box mt={isMobile ? 2 : 4} px={isMobile ? 1 : 0}>
            <Typography
                variant={isMobile ? 'subtitle1' : 'h6'}
                gutterBottom
                fontWeight="bold"
            >
                📊 이모티콘 구매 통계
            </Typography>

            {stats.length === 0 ? (
                <Typography color="text.secondary">
                    아직 구매된 이모티콘이 없습니다.
                </Typography>
            ) : (
                <ResponsiveContainer width="100%" height={isMobile ? 240 : 300}>
                    <BarChart
                        data={stats}
                        layout="vertical"
                        margin={{ left: isMobile ? 20 : 40 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis type="number" />
                        <YAxis
                            dataKey="emoticon"
                            type="category"
                            width={isMobile ? 70 : 100}
                            tick={{ fontSize: isMobile ? 12 : 14 }}
                        />
                        <Tooltip />
                        <Bar dataKey="count" fill="#3f51b5">
                            <LabelList dataKey="count" position="right" />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            )}
        </Box>
    );
};

export default EmoticonStatsChart;
